import { render, staticRenderFns } from "./juego4.vue?vue&type=template&id=1d458fb4"
import script from "./juego4.vue?vue&type=script&lang=js"
export * from "./juego4.vue?vue&type=script&lang=js"
import style0 from "./juego4.vue?vue&type=style&index=0&id=1d458fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports